import { forwardRef } from "react"

import * as LabelPrimitive from "@radix-ui/react-label"
import * as SwitchPrimitive from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

export type SwitchProps = {
  label?: string
} & SwitchPrimitive.SwitchProps

export const Switch = forwardRef(function Switch(
  { label, className, ...props }: SwitchProps,
  ref: React.Ref<HTMLButtonElement>,
) {
  return (
    <div className={cn("flex items-center", className)}>
      <SwitchPrimitive.Root
        {...props}
        className={cn(
          "focus-outline group peer shrink-0",
          "flex h-6 w-11 items-center rounded-full bg-grey-700 enabled:aria-checked:bg-colors-icon-brand",
          "disabled:bg-haze-300",
        )}
        ref={ref}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            "block h-[16px] w-[16px] translate-x-1 rounded-full transition-transform will-change-transform",
            "bg-brand-primary-100",
            "group-aria-checked:translate-x-[24px]",
            "group-disabled:bg-grey-200",
          )}
        />
      </SwitchPrimitive.Root>
      {label ? (
        <LabelPrimitive.Root
          htmlFor={props.id}
          className={cn(
            "pl-2 select-none peer-enabled:cursor-pointer",
            "peer-enabled:text-colors-text-primary peer-disabled:text-colors-text-disabled",
          )}
        >
          <span className="text-body1 text-current">{label}</span>
        </LabelPrimitive.Root>
      ) : null}
    </div>
  )
})
